import React from "react";
import "./request-status.scss";

const statusColors: { [key: string]: string } = {
    "Pending": "status-pending",
    "Approved": "status-approved",
    "Rejected": "status-rejected",
    "Active": "status-active",
    "Inactive": "status-inactive",
    "Primary": "status-primary",
    "Secondary": "status-secondary",
    "Service": "status-primary",
    "Sub-service": "status-secondary",
    "Merchandise": "status-pending",
};

const RequestStatus: React.FC<{ status: string }> = ({ status }) => {
    return (
        <span
            className={`status-badge  ${statusColors[status]} table-cell-ellipsis`}
        >
            {status}
        </span>
    );
};

export default RequestStatus;
